import React, {useState, useEffect} from "react";
import {Button, Col, Form, Input, Row, Space, message} from "antd";
import {EditOutlined, CheckOutlined, CloseOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useStore} from "hooks/useStore";

const CourierSummaryOssNumber = ({ossNumber: initialOssNumber, onSave, selectedOssNumber}) => {
    const {t} = useTranslation();
    const [isEditing, setIsEditing] = useState(false);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const stores = useStore();

    useEffect(() => {
        if (selectedOssNumber !== undefined) {
            form.setFieldsValue({ossNumber: selectedOssNumber});
        } else {
            form.setFieldsValue({ossNumber: initialOssNumber || ""});
        }
    }, [selectedOssNumber, initialOssNumber]);

    const handleEdit = () => {
        form.setFieldsValue({ossNumber: selectedOssNumber || initialOssNumber || ""});
        setIsEditing(true);
    };

    const handleCancel = () => {
        setIsEditing(false);
        form.resetFields();
    };

    const handleSubmit = async values => {
        try {
            setLoading(true);
            await onSave({ossNumber: values.ossNumber});
            setIsEditing(false);
        } catch (error) {
            console.error("Error updating OSS number:", error);
            message.error(
                error.response?.data?.message ||
                    t("ÖSS Poliçe Numarası güncellenirken bir hata oluştu")
            );
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = e => {
        const value = e.target.value;
        const filtered = value.replace(/[^0-9]/g, "");
        form.setFieldsValue({ossNumber: filtered});
    };

    return (
        <Form
            form={form}
            onFinish={handleSubmit}
            initialValues={{ossNumber: selectedOssNumber || initialOssNumber || ""}}
        >
            <Row gutter={[8, 8]} align="middle">
                <Col flex="auto">
                    {isEditing ? (
                        <Form.Item
                            name="ossNumber"
                            rules={[
                                {required: true, message: t("Zorunlu Alan")},
                                {
                                    pattern: /^\d+$/,
                                    message: t("Sadece rakam girebilirsiniz")
                                },
                                {min: 3, message: t("En az 3 karakter olmalı")},
                                {max: 15, message: t("En fazla 15 karakter olmalı")}
                            ]}
                            style={{marginBottom: 0}}
                        >
                            <Input
                                placeholder={t("ÖSS Poliçe Numarasını Giriniz")}
                                maxLength={15}
                                onChange={handleInputChange}
                            />
                        </Form.Item>
                    ) : (
                        <div style={{padding: "5px 0"}}>
                            {selectedOssNumber || initialOssNumber || t("-")}
                        </div>
                    )}
                </Col>
                <Col>
                    {stores.meStore.checkRole("updateCourierOssNumber") &&
                        (isEditing ? (
                            <Space>
                                <Button
                                    type="text"
                                    icon={<CheckOutlined />}
                                    htmlType="submit"
                                    loading={loading}
                                />
                                <Button
                                    type="text"
                                    icon={<CloseOutlined />}
                                    onClick={handleCancel}
                                    disabled={loading}
                                />
                            </Space>
                        ) : (
                            <Button type="text" icon={<EditOutlined />} onClick={handleEdit} />
                        ))}
                </Col>
            </Row>
        </Form>
    );
};

export default CourierSummaryOssNumber;
